module.exports = __webpack_public_path__ + "index/img/vip.aa1e8e98.png";